import { render, staticRenderFns } from "./Cardio.vue?vue&type=template&id=2526d71a&scoped=true&"
import script from "./Cardio.vue?vue&type=script&lang=js&"
export * from "./Cardio.vue?vue&type=script&lang=js&"
import style0 from "./Cardio.vue?vue&type=style&index=0&id=2526d71a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2526d71a",
  null
  
)

export default component.exports